module.exports = __webpack_public_path__ + "riceBG-bw2.010ae3956456c4228be0.png";


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/assets/img/riceBG-bw2.png
// module id = ../../../../../src/assets/img/riceBG-bw2.png
// module chunks = styles